import React from 'react';
import { Box } from '@mui/material';
import { useLocation } from "react-router-dom";
import PageLoadingSkeleton from '../../skeletons/PageLoadingSkeleton';
import { styled } from "@mui/material/styles";
var _ = require('lodash');

const StyledBox = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.primary.light,
    display: 'flex',
    // flexDirection: 'row',
    height: '100%',
    width: '100%',
    // padding: theme.spacing(2),
}));



const SettingsContent = ({ subMenuData, rootURL, componentMap }) => {
    const location = useLocation();
    if (subMenuData === null) return <PageLoadingSkeleton variant={"rectangular"} marginx={0} marginy={0} count={1} height={500} />;
    let data = _.orderBy(subMenuData, ['order'], ['asc'])
    // console.log(data, rootURL, componentMap, label, location.pathname, "this is data inside submenu")

    function Renderer(config) {
        // console.log(config, "this is renderer config")
        if (typeof componentMap[config.component.name] !== "undefined") {
            return componentMap[config.component.name];
        }
    }
    return (
        <StyledBox >
            {location.pathname == rootURL ?
                componentMap['general']
                :
                data.map((menuItem) => {
                    if (location.pathname == `${rootURL}/${menuItem.url}`) {
                        // console.log("This is the comparison", location, menuItem)
                        return Renderer(menuItem)
                    }
                })}
        </StyledBox>

    )
};

export default SettingsContent;
